<template>
    <div
        class="d-flex justify-content-between cursor-pointer"
        @click="copy"
    >
        <span>{{ formattedValue }}</span>
        <span
            v-if="copied"
            class="text-success"
        >
            <i class="fa fa-fw fa-check" /> Copied
        </span>
        <span v-else>
            <i class="fa fa-fw fa-copy" /> Copy
        </span>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: null,
        },
        obscure: {
            type: Boolean,
            default: false,
        },
        maxLength: {
            type: Number,
            default: 50,
        },
    },
    data() {
        return {
            copied: false,
        };
    },
    computed: {
        formattedValue() {
            let value = this.value || '';

            if (this.obscure) {
                value = value.substring(0, 3) + '*'.repeat(value.length - 3);
            }

            if (value.length > this.maxLength) {
                value = `${value.substring(0, this.maxLength)}...`;
            }

            return value;
        },
    },
    methods: {
        copy() {
            navigator.clipboard.writeText(this.value);
            this.copied = true;
            setTimeout(() => {
                this.copied = false;
            }, 5000);
        },
    },
};
</script>
